export default __webpack_public_path__ + "static/media/chevron-left.inline.5c83b604.svg";